import Blog from '~/assets/images/Blog.png'
import DienMayXanh from '~/assets/images/dienmayxanh.jpg'
import Zing from '~/assets/images/Zing.jpg'
export const dataProject = [
  {
    title: 'Zing MP3',
    img: Zing,
    date: '02/2023',
    desc: 'Clone Zing Mp3 , play music and Video , toast Error , search music , responsive ...',
    link: 'https://zing-thanhlinhna182025.vercel.app',
    tech: ['React', 'Redux', 'Tailwindcss', 'ChartJS', 'Tooltip', 'Express', 'ZingMp3-Api']
  },
  {
    title: 'Clone Điện Máy Xanh',
    img: DienMayXanh,
    date: '10/2022',
    desc: 'E-commerce , Introduce products, create shopping carts, create orders, create customer information',
    link: 'https://github.com/thanhlinhna182025/dienmayxanh',
    tech: ['HTML', 'SASS', 'Jquery', 'Javascript', 'NodeJS', 'Express', 'MongooseDB']
  },
  {
    title: 'Blog',
    img: Blog,
    date: '6/2022',
    desc: 'Personal blog , CRUD post , register , login',
    link: 'https://github.com/thanhlinhna182025/blog-usecontext',
    tech: ['React', 'CSS', 'Javascript', 'NodeJS', 'Express', 'MongooseDB', 'JWT']
  }
]

export const dataTech = [
  {
    name: 'Photoshop',
    level: 'A'
  },
  {
    name: 'HTML',
    level: 'A'
  },
  {
    name: 'CSS, SASS, Tailwindcss',
    level: 'A'
  },
  {
    name: 'React',
    level: 'B'
  },
  {
    name: 'Javascript',
    level: 'B'
  },
  {
    name: 'Jquery, Typescript',
    level: 'B'
  },
  {
    name: 'NodeJs , Express',
    level: 'B'
  }
]
